import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbDownOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.3 13.186c1.428-.067 1.997-.362 2.261-.626.3-.299.64-.993.64-2.893V6.333c0-1.9-.34-2.594-.64-2.894-.264-.263-.833-.558-2.26-.625zM16.5 2.8H7.505c-1.72.008-2.46.315-2.852.66-.396.35-.8 1.06-1.043 2.79l-.703 5c-.245 1.742-.009 2.294.115 2.455.081.105.431.436 2.007.488h6.272v4.8c0 1.287.385 1.881.974 2.162a.37.37 0 0 0 .367-.018.4.4 0 0 0 .208-.315c.215-2.644 1.385-4.76 3.146-6.95l.504-.628zM1.125 11c-.505 3.59.47 4.889 3.875 4.993h4.5v3c0 1.624.517 3.08 2 3.787 1.415.675 3.023-.318 3.144-1.812.174-2.14 1.106-3.917 2.755-5.968h.268c4 0 5.333-1.333 5.333-5.333V6.333C23 2.333 21.668 1 17.667 1H7.5c-3.728.017-5.15 1.276-5.673 5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ThumbDownOutlinedSize24Glyph.displayName = 'ThumbDownOutlinedSize24Glyph';
